export default __webpack_public_path__ + "static/media/division-5.91b0892e.png";